import { render, staticRenderFns } from "./TapOn.vue?vue&type=template&id=7610f470&"
import script from "./TapOn.vue?vue&type=script&lang=js&"
export * from "./TapOn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports